import { Label } from '../../components/Label';
import * as Styled from './Content.styles';

const Content = ({ labels, title, text, titleVariant = 'h2' }) => {
  return (
    <Styled.Content>
      <Styled.Labels>
        {labels.map((label) => (
          <Label key={label}>{label}</Label>
        ))}
      </Styled.Labels>

      {title && <Styled.Title variant={titleVariant}>{title}</Styled.Title>}

      {text && <Styled.Text variant="body16">{text}</Styled.Text>}
    </Styled.Content>
  );
};

export default Content;
